import { Component, DestroyRef, OnInit, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ExportsMonitoringService } from 'exports/services/exports-monitoring.service';
import { ImportsMonitoringChannelDrilldownComponent } from './imports-monitoring-channel-drilldown/imports-monitoring-channel-drilldown.component';
import { ImportsMonitoringChannelOverviewComponent } from './imports-monitoring-channel-overview/imports-monitoring-channel-overview.component';

@Component({
    selector: 'app-imports-monitoring',
    imports: [ImportsMonitoringChannelDrilldownComponent, ImportsMonitoringChannelOverviewComponent],
    templateUrl: './imports-monitoring.component.html',
    styleUrl: './imports-monitoring.component.scss',
})
export class ImportsMonitoringComponent implements OnInit {
    sourceId = signal<string | null>(null);

    constructor(
        private route: ActivatedRoute,
        private destroyRef: DestroyRef,
        private exportsMonitoringService: ExportsMonitoringService,
    ) {}

    ngOnInit(): void {
        this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
            const sourceId = params['sourceId'];
            this.sourceId.set(sourceId || null);
        });
    }
}
